import { normalizeFilename } from '../../../../utils/fileUtils';
import { IManagementAPIClaimUploadSignedUrlRequest } from '../../../../types/management-api/claims/upload/request';

export const transformFileUploadRequestParams = (
  files: File[]
): IManagementAPIClaimUploadSignedUrlRequest => {
  return { files: files.map(file => normalizeFilename(file.name)) };
};
